import { useCallback, useEffect, useRef } from "react";

const useInfiniteScroll = (
	onLoadMore,
	hasMore,
	isLoading,
	rootMargin = "0px 0px 400px 0px",
) => {
	const observer = useRef(null);
	// Refs keep the latest values accessible inside the observer callback
	// without ever needing to recreate the observer (which would re-fire
	// immediately on an already-visible sentinel and cause double fetches).
	const hasMoreRef = useRef(hasMore);
	const isLoadingRef = useRef(isLoading);
	const onLoadMoreRef = useRef(onLoadMore);
	const rootMarginRef = useRef(rootMargin);

	useEffect(() => {
		hasMoreRef.current = hasMore;
	}, [hasMore]);
	useEffect(() => {
		isLoadingRef.current = isLoading;
	}, [isLoading]);
	useEffect(() => {
		onLoadMoreRef.current = onLoadMore;
	}, [onLoadMore]);
	useEffect(() => {
		rootMarginRef.current = rootMargin;
	}, [rootMargin]);

	const sentinelRef = useCallback((node) => {
		if (observer.current) observer.current.disconnect();
		if (!node) return;
		observer.current = new IntersectionObserver(
			(entries) => {
				if (
					entries[0].isIntersecting &&
					hasMoreRef.current &&
					!isLoadingRef.current
				) {
					onLoadMoreRef.current();
				}
			},
			{ rootMargin: rootMarginRef.current },
		);
		observer.current.observe(node);
	}, []); // empty - observer is created once for the lifetime of the sentinel node

	return sentinelRef;
};

export default useInfiniteScroll;
